export default {"src":"/_next/static/media/iot_logo_0312041018.a92c9633.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};